import React from 'react';
import TabOfDataTable from '../../../Elements/DataTable/TabOfDataTable';
import TpClientInvoiceService from '../../../Services/TpClientInvoiceService';
import AppliedTpClientInvoiceItem from '../../../Domain/AppliedTpClientInvoiceItem';
import TpClientPaymentAppliedReportSearchParams from './TpClientPaymentAppliedReportSearchParams';

export default class AppliedTpClientInvoiceReportAdmin extends React.Component {
  static defaultProps = {};

  constructor(props) {
    super(props);

    this.state = {
      allItemsInTheSearchSetAreSelected: false,
      itemList: [],
      numberOfElementsInTheTable: 0,
      selectedItem: {},
      searchItem: new TpClientPaymentAppliedReportSearchParams(),
    };
  }

  render() {
    return (
      <div className='contentwrapper'>
        <TabOfDataTable
          type={AppliedTpClientInvoiceItem}
          serviceFunction={TpClientInvoiceService.GetAppliedListBySearching}
          convertDBItemsFunction={TpClientInvoiceService.ConvertDBItems}
          searchItem={this.state.searchItem}
          orderBy='TpClientPaymentId'
          orderDirection='Desc'
          errorCode='ACIA109'
          changeOfItemListFunction={(itemList, numberOfElementsInTheTable) =>
            this.setState({ itemList, numberOfElementsInTheTable })
          }
          changeOfAllItemsAreSelectedFunction={(allItemsInTheSearchSetAreSelected) => {
            this.setState({ allItemsInTheSearchSetAreSelected });
          }}
          showSearchStrip={true}
          searchParamsType={TpClientPaymentAppliedReportSearchParams}
        />
      </div>
    );
  }
}
